"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM5.25,18.09l2-4.64,3.31,3.31-4.64,2a.5.5,0,0,1-.55-.11A.49.49,0,0,1,5.25,18.09Zm2.59-5.46,6.29-6.3,0,0,3.51,3.52-6.29,6.3Zm7-7s0,0,0,0l1.49-1.48a.48.48,0,0,1,.7,0L19.85,7a.48.48,0,0,1,0,.7L18.37,9.16Z"
  }));
};

exports["default"] = _default;